<template>
  <div>
    <VueTinymce id="tinymce" v-model="content" :setting="setting"></VueTinymce>
    <div style="margin-top: 10px">
      <!-- <Button type="primary" @click="handlePolish" class="padding">润色</Button>
      <Button type="primary" @click="handlePolish" class="padding">纠错</Button> -->
    </div>
  </div>
</template>

<script>
import { postAliyunData } from '../richTextEditor/api';
export default {
  components: {},
  props: {
    value: {
      type: null,
      default: '',
    },
    isTable: {
      type: Boolean,
      default: true,
    },
    setHeight: {
      type: Number,
      default: 350,
    },
  },
  data() {
    return {
      content: this.value,

      setting: {
        branding: false,
        toolbar:
          'undo redo | fullscreen | styles | fontsize | fontsizeselect | formatselect alignleft aligncenter alignright alignjustify | print preview | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | emoticons | removeformat | powerpaste ',
        fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
        toolbar_drawer: 'sliding',
        quickbars_selection_toolbar:
          'removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor',
        plugins: [
          'advlist',
          'autolink',
          'link',
          'image',
          'lists',
          'charmap',
          'preview',
          'anchor',
          'pagebreak',
          'searchreplace',
          'wordcount',
          'visualblocks',
          'visualchars',
          'code',
          'fullscreen',
          'insertdatetime',
          'media',
          this.isTable ? 'table' : '',
          'emoticons',
          'help',
        ],
        language: 'zh_CN', // 本地化设置
        height: this.setHeight,
        images_upload_url:
          process.env.VUE_APP_BASE_API + '/admin/File/UploadEditorImage', // 上传图片的处理 URL
        automatic_uploads: true, // 自动上传
        //    添加扩展插件
        external_plugins: {
          powerpaste: '/tinymce/powerpaste/plugin.min.js',
        },
        images_upload_handler: (blobInfo) => {
          const p = new Promise((resolve) => {
            resolve(`data:${blobInfo.blob().type};base64,${blobInfo.base64()}`);
          });

          return p;
        },
      },
    };
  },
  methods: {
    //润色
    async handlePolish() {
      var AppCode = 'APPCODE ba4a7e8d48fe4d94b0ffe7ed89ea2bdd';

      var res = await postAliyunData(
        'https://youhua.market.alicloudapi.com/textPolish',
        {
          src_text: encodeURIComponent(this.content),
        },
        AppCode,
      );

      if (res.data.success) {
        console.log(res.data.data, '润色数据');
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 转换特定特殊字符为字符串
    convertSpecialCharacters(html) {
      return html
        .replace(/☑/g, '\\u2611') // 转换 ☑
        .replace(/☐/g, '\\u2610') // 转换 ☐
        .replace(/©/g, '\\u00A9') // 转换 ©
        .replace(/™/g, '\\u2122'); // 转换 ™
    },
    onInputChange(newContent) {
      console.log('编辑器改变');
      this.content = newContent; // 更新本地 content
      this.$emit('input', newContent); // 向父组件发出 input 事件
    },
  },
  watch: {
    value(newVal) {
      this.content = newVal;
    },
    content(newVal) {
      let cont = this.convertSpecialCharacters(newVal);
      this.$emit('input', this.$encodeEmoji(cont)); // 向父组件发出 input 事件
    },
  },
};
</script>

<style scoped>
::v-deep .tox .tox-promotion-link {
  display: none !important;
}
/* 添加你的样式 */
</style>
